export const USER_SIGNIN_REQUEST = 'USER_SIGNIN_REQUEST';
export const USER_SIGNIN_SUCCESS = 'USER_SIGNIN_SUCCESS';
export const USER_SIGNIN_FAIL = 'USER_SIGNIN_FAIL';

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL';

export const USER_EDIT_REQUEST = 'USER_EDIT_REQUEST';
export const USER_EDIT_SUCCESS = 'USER_EDIT_SUCCESS';
export const USER_EDIT_FAIL = 'USER_EDIT_FAIL';

export const UPLOAD_AVATAR_REQUEST = 'UPLOAD_AVATAR_REQUEST';
export const UPLOAD_AVATAR_SUCCESS = 'UPLOAD_AVATAR_SUCCESS';
export const UPLOAD_AVATAR_FAIL = 'UPLOAD_AVATAR_FAIL';

export const LIVECHAT_CREDENTIALS_SUCCESS = 'LIVECHAT_CREDENTIALS_SUCCESS';
export const LIVECHAT_CREDENTIALS_FAIL = 'LIVECHAT_CREDENTIALS_SFAIL';

export const USER_SIGNOUT = 'USER_SIGNOUT';
export const SET_INIT_STATE = 'SET_INIT_STATE';
